import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import QuestionForm from 'component/organism/workflow/forms/questions/QuestionForm';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
const QuestionModal = ({ isOpen, onClose, title, id, isError }) => {
  const { workflowData, setWorkflowData, selectedNode } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      question: selectedNode?.question?.map((q, index) => ({
        questionText: q.questionText || '',
        sourceHandle: q.sourceHandle || `source-${id}-${index}`,
      })) || [{ questionText: '', sourceHandle: `source-${id}-0` }],
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      question: Yup.array().of(
        Yup.object().shape({
          questionText: Yup.string().required('Question is required'),
          sourceHandle: Yup.string().required(),
        })
      ),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {},
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        formik.setSubmitting(false);
        const { question } = formik.values;
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id ? { ...node, question, is_Error: isError } : node
        );
        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <QuestionForm formik={formik} nodeId={id} />
    </RightSlider>
  );
};

export default QuestionModal;
